import { logDispatcher } from "src/app/core/decorators/state.decorators";
import { IdentificationType } from "../../models/identification-type.model";

export namespace IdentificationTypeActions {
    @logDispatcher
    export class GetIdentificationTypes {
      static readonly type = '[IdentificationType] GetIdentificationTypes';
      constructor() {}
    }
  
    @logDispatcher
    export class GetIdentificationTypesSuccess {
      static readonly type = '[IdentificationType] GetIdentificationTypesSuccess';
      constructor(public identificationTypes: IdentificationType[]) {}
    }
  
    @logDispatcher
    export class GetIdentificationTypesFail {
      static readonly type = '[IdentificationType] GetIdentificationTypesFail';
      constructor(public error: any) {}
    }
}